<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="">{{ getTitle }}</h1>

    <!-- search -->
    <view-data-search :loading="loading" @search="doSearch" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ViewDataSearch from './ViewDataSearch'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'
export default {
  name: 'ViewDataForm',
  components: {
    ViewDataSearch,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },

      showModal: false,
      selectedItem: null,

      showConfirmModal: false,
      confirmModalTitle: '',
      confirmModalText: '',
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    getTitle() {
      switch (this.$route.name) {
        case 'viewDataFft':
          return 'V_FFT_VAIDMUO_TEISES duomenys'
        case 'viewDataFate':
          return 'V_FATE_VAIDMUO_TEISES duomenys'
        default:
          return ''
      }
    },
    getURL() {
      switch (this.$route.name) {
        case 'viewDataFft':
          return 'view-data/fft'
        case 'viewDataFate':
          return 'view-data/fate'
        default:
          return ''
      }
    },
    headers() {
      return [
        {
          text: this.$t('FIZ_KODAS_TEIKEJO'),
          align: 'center',
          value: 'fiz_kodas_teikejo',
          hide: this.$route.name === 'viewDataFate',
        },
        {
          text: this.$t('OBJ_ID_TEIKEJO'),
          align: 'center',
          value: 'obj_id_teikejo',
          hide: this.$route.name === 'viewDataFft',
        },
        {
          text: this.$t('OBJ_KODAS_TEIKEJO'),
          align: 'center',
          value: 'obj_kodas_teikejo',
          hide: this.$route.name === 'viewDataFft',
        },
        {
          text: this.$t('AMN_ID_TEIKEJO'),
          align: 'center',
          value: 'amn_id_teikejo',
        },
        {
          text: this.$t('FIZ_KODAS_GAVEJO'),
          align: 'center',
          value: 'fiz_kodas_gavejo',
        },
        {
          text: this.$t('OBJ_ID_GAVEJO'),
          align: 'center',
          value: 'obj_id_gavejo',
        },
        {
          text: this.$t('OBJ_KODAS_GAVEJO'),
          align: 'center',
          value: 'obj_kodas_gavejo',
        },
        {
          text: this.$t('AMN_ID_GAVEJO'),
          align: 'center',
          value: 'amn_id_gavejo',
        },
        {
          text: this.$t('FAVA_ID'),
          align: 'center',
          value: 'fava_id',
        },
        {
          text: this.$t('FAVA_PAVAD'),
          align: 'center',
          value: 'fava_pavad',
        },
        {
          text: this.$t('FFT_ID'),
          align: 'center',
          value: 'fft_id',
          hide: this.$route.name === 'viewDataFate',
        },
        {
          text: this.$t('FFT_PAVAD'),
          align: 'center',
          value: 'fft_pavad',
          hide: this.$route.name === 'viewDataFate',
        },
        {
          text: this.$t('FATE_ID'),
          align: 'center',
          value: 'fate_id',
          hide: this.$route.name === 'viewDataFft',
        },
        {
          text: this.$t('FATE_PAVAD'),
          align: 'center',
          value: 'fate_pavad',
          hide: this.$route.name === 'viewDataFft',
        },
        {
          text: this.$t('IGA_ID'),
          align: 'center',
          value: 'iga_id',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    setItemParam(item) {
      item.canViewInModal = true
      return item
    },
    setlistParams() {
      if (
        this.listParams &&
        this.pagination.pageSize != this.listParams.pageSize &&
        this.listParams.pageSize != null
      ) {
        this.pagination.pageSize = this.listParams.pageSize
      }
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }
      const data = {
        ...this.pagination,
        search: this.searchData,
      }
      this.$axios
        .post(this.getURL, data)
        .then((res) => {
          this.listData = res.data.items
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    doSearch(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
  },
}
</script>
